import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import { getListTaiSan, updateDataSearch } from "actions/DanhSachTaiSan/";
import ReactDropdown from "react-dropdown";
import { DanhSachTaiSanCombo } from "constants/danhSachTaiSanConst";
import StoreApi from "service/storeApi";

export const SearchTaiSan = (props) => {
  const dispatch = useDispatch();
  const [dataCombo, setdataCombo] = useState(DanhSachTaiSanCombo.KhoCombo);
  const dataSearch = useSelector((state) => state.dataSearchTaiSan); //dataSearchTaiSan dinh nghia o rootreducer
  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  // const [stores] = useState(initStore);
  useEffect(() => {
    StoreApi.combo({}).then((response) => {
      const dataComboReturn = response.data.map((item) => ({
        value: item.value,
        label: item.StoreName,
      }));
      //setdataCombo(dataComboReturn);
      setdataCombo([
        {
          value: 0,
          label: "Kho",
        },
        ...dataComboReturn,
      ]);
    });
  }, []);

  const updateState = (field, value) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: value,
      })
    );
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const updateDropdown1 = (field) => (e) => {
    updateState(field, e.value);
  };
  const onSearch = () => {
    props.onHide(false);
    dispatch(getListTaiSan(dataSearch));
  };
  const handleKeyDown = () => {
    return;
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/logo-quan-ly-tai-san.png" />
          </span>{" "}
          Tìm kiếm nâng cao
        </h4>

        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row repeater-default">
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Mã tài sản</label>
              <br />
              <input
                name="mataisan"
                className="form-control input-sm"
                placeholder=""
                onChange={updateTextValue("mataisan")}
                onKeyDown={handleKeyDown}
                value={dataSearch.mataisan}
              />
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Tên tài sản</label>
              <br />
              <input
                name="tentaisan"
                className="form-control input-sm"
                placeholder=""
                onChange={updateTextValue("tentaisan")}
                onKeyDown={handleKeyDown}
                value={dataSearch.tentaisan}
              />
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="bio" className="cursor-pointer">
                Trạng thái
              </label>
              <ReactDropdown
                options={DanhSachTaiSanCombo.TrangThaiTaiSanCombo}
                value={DanhSachTaiSanCombo.TrangThaiTaiSanDefault}
                onChange={updateDropdown1("trangthai")}
                name="trangthai"
                controlClassName="form-control input-sm"
                placeholder="- Trạng thái -"
              />
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Kho</label>
              <select
                name="kho"
                className=" form-control input-sm"
                value={dataSearch.kho}
                onChange={updateDropdown("kho")}
              >
                {dataCombo &&
                  dataCombo.map((item, idx) => (
                    <option className  key={"objComboStore1" + idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Tình trạng</label>
              <br />
              <ReactDropdown
                options={DanhSachTaiSanCombo.TinhTrangCombo}
                value={DanhSachTaiSanCombo.TinhTrangDefault}
                onChange={updateDropdown1("tinhtrang")}
                name="tinhtrang"
                controlClassName="form-control input-sm"
                placeholder=""
              />
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-9 col-12">
              <label for="tel-input">Ghi chú</label>
              <br />
              <textarea
                rows="1"
                class="form-control input-sm"
                name="ghichu"
                onChange={updateTextValue("ghichu")}
                onKeyDown={handleKeyDown}
                value={dataSearch.ghichu}
              ></textarea>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>
         &nbsp;  Đóng &nbsp;
        </button>
           <button
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSearch}
        >
          <span>
          <i class="mdi mdi-magnify"></i>
          </span>{" "}
          &nbsp; Tìm kiếm &nbsp;
         </button>
      </Modal.Footer>
    </Modal>
  );
};
